import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import ConnectIpsServices from "../services/connectIpsServices";

const PaymentError = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const orgcode = localStorage.getItem("orgcode");

  const orderResponse =
    location.state?.orderResponse ||
    JSON.parse(localStorage.getItem("orderResponse"));
  console.log("🚀 ~ PaymentError ~ orderResponse:", orderResponse);
  const orgData =
    location.state?.orgData || JSON.parse(localStorage.getItem("orgData"));
  const paymentType =
    location.state?.paymentType || localStorage.getItem("paymentType");

  const [paymentStatus, setPaymentStatus] = useState(null);
  const [error, setError] = useState(null);

  const [loading, setLoading] = useState(true);


  // Get order details from localStorage
  const lastOrder = JSON.parse(localStorage.getItem("orderResponse") || "{}");
  console.log("🚀 ~ PaymentSuccess ~ lastOrder:", lastOrder);
  const orderRef = lastOrder?.orderRefrenceId;

  useEffect(() => {
    console.log(
      "useEffect triggered, orderRef:",
      orderRef,
      "orgcode:",
      orgcode
    );
    if (!orderRef || !orgcode) {
      console.log("Skipping API call: orderRef or orgcode is missing");
      return;
    }

    const fetchPaymentStatus = async () => {
      try {
        setLoading(true);
        const response = await ConnectIpsServices.validateConnectIpsPayment(
          orderRef,
          orgcode
        );
        setPaymentStatus(response.data);
      } catch (err) {
        setError(err?.response?.data || err);
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentStatus();
  }, [orderRef, orgcode]);

  useEffect(() => {
    // Preserve state for refresh/back navigation.
    if (orderResponse) {
      localStorage.setItem("orderResponse", JSON.stringify(orderResponse));
    }
    if (orgData) {
      localStorage.setItem("orgData", JSON.stringify(orgData));
    }
    if (paymentType) {
      localStorage.setItem("paymentType", paymentType);
    }
  }, [orderResponse, orgData, paymentType]);

  return (
    <Container
      fluid
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        maxWidth: "1600px",
        margin: "0 auto",
        paddingLeft: "20px",
        paddingRight: "20px",
      }}
    >
      <Row>
        <Col md={{ size: 8, offset: 2 }} lg={{ size: 6, offset: 3 }}>
          <Card
            style={{
              borderRadius: "15px",
              boxShadow: "0 5px 15px rgba(0,0,0,0.05)",
              border: "none",
            }}
          >
            <CardBody style={{ padding: "40px", textAlign: "center" }}>
              <div
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#f8d7da",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                }}
              >
                <i
                  className="ri-error-warning-fill"
                  style={{ fontSize: "48px", color: "#dc3545" }}
                ></i>
              </div>

              <h2
                style={{
                  fontSize: "28px",
                  fontWeight: "bold",
                  marginBottom: "15px",
                  color: "#333",
                }}
              >
                Payment Failed
              </h2>

              <p
                style={{
                  fontSize: "16px",
                  color: "#666",
                  marginBottom: "30px",
                  lineHeight: "1.6",
                }}
              >
                We encountered an error processing your payment. Please check
                your payment details and try again. If the problem persists,
                contact support.
              </p>

              <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
                <Button
                  color="danger"
                  style={{
                    flex: 1,
                    minWidth: "150px",
                    borderRadius: "10px",
                    fontWeight: "500",
                  }}
                  onClick={() => {
                    navigate(`/${orgcode}/customer-checkout`, {
                      state: {
                        orderResponse,
                        orgData,
                        paymentType,
                      },
                    });
                  }}
                >
                  Try Again
                </Button>

                <Button
                  color="primary"
                  style={{
                    flex: 1,
                    minWidth: "150px",
                    borderRadius: "10px",
                    fontWeight: "500",
                    backgroundColor: "primary",
                    color: "#fff",
                    border: "none",
                  }}
                  onClick={() => navigate(`/${orgcode}`)}
                >
                  Back to Menu
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default PaymentError;
